import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { PlanInfo } from '../../types/generated/Plan.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetPlansQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetPlansQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, plans?: Array<{ __typename?: 'Plan', activeStorageLimit?: number | null, archivedStorageLimit?: number | null, cost: number, defaultPlan: boolean, eligibility: Types.PlanEligibility, enterprise?: boolean | null, id: string, mountedStorageLimit?: number | null, mountedStorageTrialLimit?: number | null, name?: string | null, paymentMethod: Types.PlanPaymentMethod, period: Types.PlanPeriod, perUserStorageIncrement?: number | null, projectLimit?: number | null, tier: Types.PlanTier, title: string, userLimit?: number | null, userMax?: number | null, version?: number | null, workspaceLimit?: number | null, availableFeatures: { __typename?: 'AvailableFeatures', allowedDomains: boolean, commentAttachments?: boolean | null, customBrandedShares?: boolean | null, devices: boolean, disableShareComments?: boolean | null, disableShareDownloads?: boolean | null, disableSharePreviousVersions?: boolean | null, fourKPlayback: boolean, hdr: boolean, id: string, mountedStorage: boolean, mountedStorageOverprovisioningAllowed: boolean, passwordProtectedShares: boolean, privateProjects: boolean, reelPlayer: boolean, restrictedFolders?: boolean | null, secureSharing: boolean, sessionBasedWatermarking: boolean, shareLinkExpiration: boolean, staticWatermark?: boolean | null, storageConnect?: boolean | null, transcription?: boolean | null, unlimitedWatermarkTemplates?: boolean | null }, addOns?: Array<{ __typename?: 'PlanAddOn', id: string, modifier?: string | null }> | null }> | null } | null };


export const GetPlans = /*#__PURE__*/ gql`
    query GetPlans($accountId: ID!) {
  account(by: {id: $accountId}) {
    id
    plans {
      ...PlanInfo
    }
  }
}
    ${PlanInfo}` as unknown as DocumentNode<GetPlansQuery, GetPlansQueryVariables>;

          

          export const useGetPlansQuery = (options?:QueryHookOptions<GetPlansQuery, GetPlansQueryVariables>) => useQuery(GetPlans, options);

          

          export type GetPlansQueryOptions = QueryHookOptions<GetPlansQuery, GetPlansQueryVariables>;

          

          export const useGetPlansLazyQuery = (options?:LazyQueryHookOptions<GetPlansQuery, GetPlansQueryVariables>) => useLazyQuery(GetPlans, options);

          

          export type GetPlansQueryResult = ReturnType<typeof useGetPlansQuery>;

          
